export default __webpack_public_path__ + "locales/pl/ChangePortalOwner.json?hash=b18a9235758b4f2c8711860186deebef";